module.exports = __webpack_public_path__ + "img/ios_app.67203ff2.svg";